// extracted by mini-css-extract-plugin
module.exports = {"fileContainer":"addNewFileForm_fileContainer__3idbL","fileContainerRedesign":"addNewFileForm_fileContainerRedesign__2lklY"};